import React, { useEffect, useState } from 'react'

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export const YearPicker = ({ onChange }: {onChange: (start?: Date, end?: Date) => void}) => {
  const [startDate, setStartDate] = useState<Date>()
  const [endDate, setEndDate] = useState<Date>()

  useEffect(() => {
    if (!startDate || (endDate && startDate > endDate)) {
      setEndDate(undefined)
    }
  }, [startDate])

  useEffect(() => {
    onChange(startDate, endDate)
  }, [startDate, endDate])

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ flex: 1 }}>
        <DatePicker
          selected={startDate}
          onChange={(date: Date) => setStartDate(date)}
          className='form-control'
          showYearPicker
          dropdownMode='select'
          dateFormat='yyyy'
          isClearable
          disabledKeyboardNavigation
        />
      </div>
      <div style={{ padding: '0.375rem 0.75rem' }}>
        &ndash;
      </div>
      <div style={{ flex: 1 }}>
        <DatePicker
          selected={endDate}
          onChange={(date: Date) => setEndDate(date)}
          minDate={startDate}
          className='form-control'
          showYearPicker
          dropdownMode='select'
          dateFormat='yyyy'
          isClearable
          disabledKeyboardNavigation
        />
      </div>
    </div>
  )
}
